import { type CanvasElementType } from '@blaze-runtime/engine-domain';

import { type CommandType } from './base.commands';
import { type CommandExecutor } from './base.executor';
import { CommandPayloadFactory } from './command-payload.factory';
import { type AICommandPayload } from './command-payload.model';

export class CommandRegistry {
  private static readonly registry = new Map<string, new () => CommandExecutor<any>>();

  static register<T extends AICommandPayload<any>>(
    commandType: CommandType,
    elementType: CanvasElementType | '*',
    executorClass: new () => CommandExecutor<T>,
  ): void {
    const hash = CommandPayloadFactory.getElementCommandHashCode(commandType, elementType);
    this.registry.set(hash, executorClass as new () => CommandExecutor<any>);
  }

  static getExecutor(payload: AICommandPayload<any>): CommandExecutor<any> {
    const hash = CommandPayloadFactory.getHashCode(payload.command);
    const executorClass = this.registry.get(hash);

    if (!executorClass) {
      throw new Error(`Missing command executor for ${JSON.stringify(payload.command)}`);
    }

    return new executorClass();
  }
}
